import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ListCheckIcon } from "../../../../../../assets";
import { ApiError, LexTokenPayload } from "../../../../../models";
import { saveChatInterest } from "../../../../../services";
import { getLoggedUser, getStoredToken, openChat } from "../../../../../utils";
import { PDLButton, PDLTypography } from "../../../dna";
import "./index.scss";

interface Feature {
  text: string;
}

const features: Feature[] = [
  { text: "Geração de petições e documentos jurídicos" },
  { text: "Análise inteligente de PDFs e contratos" },
  { text: "Pesquisa jurisprudencial avançada com IA" },
  { text: "Organização de conversas e histórico" },
];

const LexIAPresentation = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [disabled, setDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const token = getStoredToken();
  const loggedUser = useSelector(getLoggedUser);

  const navigate = useNavigate();

  const decodedToken = token ? (jwtDecode(token) as LexTokenPayload) : null;
  const isIpAccount = loggedUser.origem === "ip_auth";
  const chatEnabled = (decodedToken && decodedToken?.chat) || false;

  const handleSaveChatInterest = async () => {
    if (isIpAccount && chatEnabled) {
      return navigate("/entrar");
    }

    if (chatEnabled && token) {
      openChat(token);
      return;
    }

    setSuccessMessage(null);
    setErrorMessage(null);

    try {
      setIsLoading(true);

      await saveChatInterest();
      setDisabled(true);
      setSuccessMessage("Interesse registrado, nossa equipe entrará contato!");
    } catch (error) {
      const errorMsg =
        (error as ApiError)?.response?.data?.message ||
        "Não foi possível salvar seu pedido.";

      setErrorMessage(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="lex-ia-section" className="pdl_component_home_lex_ia">
      <div className="container">
        <div className="content">
          <h2 className="title">
            Conheça o assistente jurídico da LEX Editora
          </h2>
          <p className="description">
            O Lex-IA é o assistente jurídico inteligente que transforma sua
            rotina. Melhore suas análises, acelere pesquisas e produza
            documentos com mais eficiência. Tudo o que você precisa para
            potencializar sua atuação profissional em um só lugar.
          </p>
          <ul className="feature-list">
            {features.map((feature, index) => (
              <li key={index} className="feature-item">
                <span className="feature-icon">
                  <ListCheckIcon />
                </span>
                <span className="feature-text">{feature.text}</span>
              </li>
            ))}
          </ul>

          <div className="button-content">
            <PDLButton
              className="cta-button"
              type="submit"
              variant="primary"
              disabled={isLoading || disabled}
              onClick={handleSaveChatInterest}
            >
              {isLoading
                ? "Enviando..."
                : chatEnabled
                  ? "Acessar"
                  : "Tenho interesse na Lex-IA"}
            </PDLButton>

            <div className="feedback-message-container">
              {successMessage && (
                <Row className="mt-1">
                  <Col className="ps-0">
                    <PDLTypography size="xs" variant="success">
                      {successMessage}
                    </PDLTypography>
                  </Col>
                </Row>
              )}

              {errorMessage && (
                <Row className="mt-1">
                  <Col className="ps-0">
                    <PDLTypography size="xs" variant="danger">
                      {errorMessage}
                    </PDLTypography>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>

        <div className="image-wrapper">
          <div className="image-container">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-itbnUlbzOr0BFDfZwBQ1osNeZgwjkp.png"
              alt="Lex-IA - Assistente Jurídico Inteligente"
              className="image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LexIAPresentation;
